// seller-service support paths (relative to VITE_SELLER_API_URL, under the /api prefix).
export const supportEndpointPaths = {
  FAQ_CATEGORIES: '/api/support/faq/categories',
  FAQS: '/api/support/faq',
  TICKET_CATEGORIES: '/api/support/ticket-categories',
  TICKETS: '/api/support/tickets',
  TICKET_DETAIL: (id: string) => `/api/support/tickets/${id}`,
  PUBLIC_TICKETS: '/api/support/public/tickets',
} as const
